export default {
  login: "Login",
  account: "Account",
  register: "Register",
  loginTime: "Login Time",
  long: "Long",
  new: "New",
  content: "Content",
  companyName: "Dongcheng Branch of Xinfeng Stainless Steel Products Co., Ltd.",
  email: "Email",
  phone: "Phone Number",
  personalInformation: "Personal Information",
  personalSettings: "Personal Settings",
  password: "Password",
  logout: "Logout",
  personal_center: "Personal Center",
  workshop: "Workshop",
  personnel: "Personnel",
  problem: "Problem",
  summary: "Summary",
  question: {
    problemReport: "6S Problem Report",
    create: "Create Problem",
    auditDocuments: "Audit Documents",
    untreated: "Unprocessed",
    processing: "Processing",
    currentMonth: "Specific Problems This Month",
    recently: "Recently Occurred Problems",
    data: "Monthly Data Chart",
    specific: "Specific Problem",
    feedbackContent: "Feedback Content",
    issuesWorkshop: "No problems found in workshop this month",
    viewingIssues: "View Problems",
    deductionSituation: "Deduction Situation",
    specificLocation: "Specific Location",
    discoveryTime: "Problem Discovery Time",
    requestRectificationTime: "Requested Rectification Time",
    actualRectificationTime: "Actual Rectification Time",
    processingStatusOfEachWorkshop: "Processing Status of Each Workshop",
    workshopFeedback: "Workshop Feedback",
    frequency: "Problem Frequency"
  },
  attendance: {
    value: "Attendance",
    dongchengNoProduction: "Dongcheng Factory - Non-production",
    dongchengProduction: "Dongcheng Factory - Production",
    bakingNoProduction: "Baking - Non-production",
    bakingProduction: "Baking - Production",
    personal: "Personal Attendance",
    number: "Attendance Number",
    workCard: "Clock In",
    offDutyCard: "Clock Out",
    data: "Output Calibration Data",
    team: "Team",
    wages: "Wages",
    punching: "Punch Record",
    punchingNum: "Punch Times",
    overtimeHours: "Overtime Hours",
    worktime: "Work Hours",
    totalWork: "Total Work Hours",
    total: "Statistics",
    recosting: "Recalculate",
    worklate: "Late Minutes",
    extra: "Business Trip Hours",
    allDay: "Total Days",
    allOvertime: "Total Overtime Hours",
    allWorktime: "Total Working Hours",
    normalDay: "Normal Working Days",
    normalOvertime: "Normal Overtime Hours",
    saturdayDay: "Weekend Working Days",
    saturdayOvertime: "Weekend Overtime Hours",
    holiday: "Holiday Working Days",
    holidayOvertime: "Holiday Overtime Hours",
    absentee: "Absence Times",
    clockIn: "Clock In",
    adjust: "Adjust",
    leave: "Leave",
    supplementaryWorkingHours: "Supplementary Working Hours",
    cardReplacement: "Card Replacement",
    clockInDetails: "Clock-in Details",
    cardReplacementApplication: "Card Replacement Application",
    workHourApplication: "Work Hour Application",
    checkInAdjustment: "Clock-in Adjustment",
    leaveVerification: "Leave Verification",
    check: "Check"
  },
  mealExpenses: "Meal Expenses",
  project: "Project",
  total: "Total",
  totalScore: "Total Score",
  averageScore: "Average Score",
  totalDeductionPoints: "Total Deduction Points",
  qualified: "Qualified",
  unqualified: "Unqualified",
  remarks: "Remarks",
  class: "Category",
  index: "Index",
  all: "All",
  creationTime: "Creation Time",
  data: "Original Data",
  view: "View",
  add: "Add",
  edit: "Edit",
  query: "Query",
  update: "Update",
  save: "Save",
  delete: "Delete",
  batchDelete: "Batch Delete",
  bind: "Bind",
  cancel: "Cancel",
  confirmed: "Confirm",
  success: "Success",
  cannotBeEmpty: "Cannot be empty",
  submit: "Submit",
  clear: "Clear",
  group: "Group",
  reset: "Reset",
  details: "Details",
  export: "Export",
  noData: "No Data",
  import: "Import",
  pass: "Pass",
  fail: "Fail",
  score: "Score",
  upload: "Upload",
  img: "Photo",
  user: "User",
  moniker: "Name",
  main: "Main Interface",
  name: "Name",
  strategy: "Strategy",
  select: "Select",
  exit: "Exit",
  workType: "Work Type",
  depart: "Department",
  positions: "Position",
  morning: "Morning",
  afternoon: "Afternoon",
  date: "Date",
  wholeYears: "Whole Year",
  years: "Year",
  months: "Month",
  days: "Day",
  daysNum: "Days",
  sameDay: "Same Day",
  holidays: "Holidays",
  dateInterval: "Date Range",
  approval: "Approval",
  category: "Category",
  operation: "Operation",
  opinion: "Opinion",
  uploader: "Uploader",
  english: "English",
  chinese: "Chinese",
  thai: "Thai",
  type: "Type",
  sequence: "Sequence",
  menu: {
    viewDetails: "View Details",
    checkMonthlyCardShortages: "View Monthly Missing Cards",
    checkTheDailyCardShortage: "View Daily Missing Cards",
    workInquiriesForConsecutiveDays: "Query Consecutive 14 Days of Work",
    viewTheListOfMissingCards: "View Missing Card List",
    continuousWorkingHours: "Continuous Working Hours",
    personnelMaintenanceStatistics: "Personnel Maintenance Statistics",
    equipmentMaintenanceStatistics: "Equipment Maintenance Statistics",
    workshopMaintenanceStatistics: "Workshop Maintenance Statistics",
    importAttendance: "Import Attendance",
    lateQuery: "Late Record Query",
    absentee: "Leave Verification",
    lateSchedule: "Late Schedule",
    annualAttendanceStatistics: "Annual Attendance Statistics",
  },
  error: {
    pleaseEnterDate: "Please enter a date",
    mes: "An error occurred",
    param: "Parameter error"
  },
  mes: {
    connectionSuccessful: "Connection Successful",
    loading: "Loading...",
    disconnect: "Disconnected",
    reconnecting: "Reconnecting...",
    rconnectionFailed: "Reconnection Failed",
    pleaseEnterTheTimeCorrectly: "Please enter the correct time",
    pleaseEnterFeedbackContent: "Please enter feedback content",
    pleaseSelect: "Please select",
    pleaseEnterYourPhoneNumber: "Please enter phone number",
    chooseaMachine: "Select Machine",
    selectExamPaper: "Select Exam Paper",
    selectParticipants: "Select Participants",
    pleaseUploadPictures: "Please upload pictures",
    pleaseSelectAFollowUpPerson: "Please select a follow-up person",
    pleaseEnterAtLeastWords: "Please enter at least 20 words",
    pleaseEnterTheNameOfTheExamPaper: "Please enter the name of the exam paper",
    pleaseEnterTheSuggestedDuration: "Please enter the suggested duration",
    pleaseEnterAHeading: "Please enter a title",
    pleaseEnterInOrder: "Please enter in order"
  },
  finish: "Completed",
  create: "Pending Order",
  process: "Processing",
  faultReportingTime: "Fault Reporting Time",
  reporter: "Reporter",
  faultContent: "Fault Content",
  singlePersonReception: "Receiver",
  state: "Status",
  jan: "January",
  feb: "February",
  mar: "March",
  apr: "April",
  may: "May",
  jun: "June",
  jul: "July",
  aug: "August",
  sep: "September",
  oct: "October",
  nov: "November",
  dec: "December",
  number: "No.",
  device: {
    name: "Device",
    repairQuantity: "Repair Quantity"
  },
  accessory: "Accessory",
  stamping: "Stamping",
  braze: "Brazing",
  freeze: "Welding",
  burnishing: "Polishing",
  sanding: "Sanding",
  accessoriesPolishing: "Accessory Polishing",
  package: "Packaging",
  mold: "Mold",
  engineering: "Engineering Dept.",
  warehouse: "Warehouse",
  production: "Production Dept.",
  technology: "Technology Dept.",
  inspection: "Quality Dept.",
  equipment: "Equipment Dept.",
  finance: "Finance Dept.",
  manage: "Management Dept.",
  office: "Office",
  grade: "Score",
  inProgress: "In Progress",
  followUpCompleted: "Follow-up Completed",
  verificationCompleted: "Verification Completed",
  verificationFailed: "Verification Failed",
  option: "Option",
  fillInTheBlank: "Fill in the Blank",
  examine: {
    view: "Assessment",
    content: "Assessment Content",
    standard: "Evaluation Standard",
    poor: "Poor (below 60)",
    secondary: "Average (61-75)",
    good: "Good (76-90)",
    outstanding: "Excellent (91-100)",
    assessor: "Evaluator",
    evaluatedPerson: "Evaluatee",
    assessmentMonth: "Assessment Month",
    contentAndDefinition: "Detailed Indicator Content and Definition",
    manageGrade: "Management Score",
    metrics: "Sub Indicators",
    weight: "Weight",
    superMax: "Exceeding Max Score",
    total: {
      depart: "Department Statistics",
      workshop: "Workshop Statistics"
    },
    depart: {
      personInChargeRating: "Department Head Rating",
      ratingForm: "Annual Dongcheng Branch Department Monthly Performance Evaluation Form",
      evaluatedDepartment: "Evaluated Department",
      rating: "Department Rating",
      instructions:
        "Note: This form is used for the performance evaluation of department staff. The evaluation indicators, weights, and specific definitions are clear and detailed for practical application. Adjustments may be made based on job characteristics. The department head’s score is the average of all staff in the department."
    },
    device: {
      content: "Maintenance Content",
      ratingForm: "Dongcheng Workshop Equipment Daily Maintenance Score",
      instructions: "Note: Each item can be deducted according to severity."
    },
    logistics: {
      ratingForm: "Dongcheng Branch Lean Production Logistics Department Evaluation Form",
      instructions: `Note:
1. All department members must rate fairly and objectively. Personal conflicts must not affect fairness.
2. Submit this evaluation form to the Management Dept. for summary.
3. Engineering, Mold, and Warehouse departments: Factory rating accounts for 40%, workshop rating for 60%, final score is the average of all raters.`
    },
    satisfaction: {
      ratingDepartment: "Rating Department",
      ratingWorkshop: "Rating Workshop",
      departRatingForm: "Department Satisfaction Evaluation Form",
      workshopRatingForm: "Workshop Satisfaction Evaluation Form",
      instructions: "Note: Each item may be deducted depending on problem severity."
    },
    warehouse: {
      ingredients: "Note: Please rate warehouse staff fairly based on service attitude if you have business contact; skip if not."
    },
    workshop: {
      ratingForm: "Annual Dongcheng Branch Workshop Monthly Performance Evaluation Form",
      ratingWorkshop: "Workshop under Evaluation",
      explain: "Score Adjustment Explanation",
      instructions: "Each person in charge must submit data to the Management Dept. before the 5th of each month.",
      assessment_dimension: "Assessment Dimension",
      target_name: "Indicator Name",
      source: "Data Source",
      assessment_score: "Assessment Score",
    }
  },
  training: {
    lecturer: "Lecturer",
    name: "Training Name",
    numberOfRetakes: "Retake Count",
    startSigningIn: "Start Sign-in",
    endOfTraining: "End of Training",
    notSignedIn: "Not Signed In",
    signedIn: "Signed In",
    difficulty: "Difficulty",
    rating: "Rating",
    exam: "Exam",
    paperEditor: "Paper Editor",
    title: "Title",
    type: "Type",
    paper: "Exam Paper",
    answer: "Answer",
    parse: "Explanation",
    actualNumberOfParticipants: "Actual Participants",
    realNumber: "Expected Participants",
    attendanceRate: "Attendance Rate",
    machine: "Machine",
    date: "Training Date",
    plan: "Plan",
    checkInQRCode: "Sign-in QR Code",
    dragMe: "Drag Me",
    remarks: "(Note: Internal use, exam includes single and true/false questions, total 100 points, 90 is passing.)",
    compilerAdds: "Compiler Add",
    downloadTheExamPaper: "Download Exam Paper",
    questionnaireEditor: "Questionnaire Editor",
    pasteQuestionnaireText: "Paste Questionnaire Text",
    question: "Question Stem",
    questionType: "Question Type",
    correctAnswer: "Correct Answer",
    questionScore: "Question Score",
    fillInTheTestPaperInformation: "Fill in Exam Paper Info",
    duration: "Duration",
    multiple_choice: "Single Choice",
    single_choice: "Multiple Choice",
    true_false: "True/False",
    pasteFill: "Paste Fill",
    richTextEditing: "Rich Text Editing",
    suggestedDuration: "Suggested Duration (minutes)",
    heading: "Title"
  },
  verification: {
    quality: "Quality",
    specis: "Specification Name",
    trackingNumber: "Tracking Number",
    description: "Quality Issue Description",
    productionQuantity: "Production / Sample Quantity",
    nonconformingCount: "Defective Count / Rate",
    follower: "Follow-up Person",
    responsibleDepartment: "Responsible Department",
    responsiblePerson: "Responsible Person",
    creator: "Creator",
    formFiller: "Form Filler",
    rootCauseAnalysis: "Root Cause Analysis",
    rectificationMeasures: "Rectification Measures",
    completionTimeOfRectification: "Rectification Completion Time",
    validator: "Validator",
    verificationCompletionTime: "Verification Completion Time",
    verificationResult: "Verification Result",
    requestRectificationTime: "Requested Rectification Time",
    actualRectificationTime: "Actual Rectification Time"
  },
  hostel: {
    code: "Dormitory Code",
    facility: "Facilities",
    // 退租
    // 宿舍信息
  }
}



// WEBPACK FOOTER //
// ./src/lang/en.js